export const attendanceCapabilityForStore = (access, storeId) =>
  (access?.facilities || []).find(item => String(item.id) === String(storeId)) || {};

export const canOpenAttendanceTab = access =>
  (access?.facilities || []).some(item => Boolean(item.attendance_navigation));

export const canOpenMonthlyAttendanceTab = access =>
  (access?.facilities || []).some(item => Boolean(item.monthly_navigation));

export function attendanceStoresForTab(access, stores, tabId, homeStoreId) {
  if (!['attendance', 'monthlyAttendance'].includes(tabId)) return null;
  const navigationKey = tabId === 'attendance' ? 'attendance_navigation' : 'monthly_navigation';
  const allowed = new Set(
    (access?.facilities || [])
      .filter(item => Boolean(item[navigationKey]))
      .map(item => String(item.id))
  );
  const result = stores.filter(store => allowed.has(String(store.id)));
  if (result.length) return result;
  return stores.filter(store => String(store.id) === String(homeStoreId));
}
